import {
  CATEGORY_USER,
  GET_ALL_AGENT_DATAILS,
  GET_ALL_BILLING_TYPES_SUCCESS,
  GET_ALL_BILLING_TYPES,
  GET_AGENT_SUCCESS,
  CATEGORY_USER_ERROR,
  CATEGORY_USER_SUCCESS,
  DELETE_CATEGORY_USER,
  DELETE_CATEGORY_USER_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_SUCCESS,
  GET_USER_BY_PROJECT,
  GET_USER_BY_PROJECT_ERROR,
  GET_USER_BY_PROJECT_SUCCESS,
  SAVE_UPLOAD_GATEGORY,
  SAVE_UPLOAD_GATEGORY_ERROR,
  SAVE_UPLOAD_GATEGORY_SUCCESS,
  SUB_CATEGORY,
  SUB_CATEGORY_ERROR,
  SUB_CATEGORY_SUCCESS,
  CREATE_USERS_FOR_PROJECTS,
  CATEGORY_USER_CATEGORY_LINK,
  CATEGORY_USER_CATEGORY_LINK_SUCCESS,
  CATEGORY_USER_CATEGORY_LINK_ERROR,
  GET_PROJECT_STATUS_SUCCESS,
  GET_PROJECT_STATUS_ERROR,
  GET_PROJECT_STATUS,
  GET_PROJECT_STATUS_TOTAL_HOURS,
  GET_PROJECT_STATUS_TOTAL_HOURS_SUCCESS,
  GET_PROJECT_STATUS_TOTAL_HOURS_ERROR,
} from "./actiontype"

export const getCategory = params => {
  return {
    type: GET_CATEGORY,
    payload: params,
  }
}
export const getAllAgentDetails = () => {
  return {
    type: GET_ALL_AGENT_DATAILS,
  }
}
export const getAgentSuccess = value => {
  return {
    type: GET_AGENT_SUCCESS,
    payload: value,
  }
}
export const getAllBillingTypes = () => {
  return {
    type: GET_ALL_BILLING_TYPES,
  }
}
export const getAllBillingTypesSuccess = value => {
  return {
    type: GET_ALL_BILLING_TYPES_SUCCESS,
    payload: value,
  }
}

export const getCategorySuccess = value => {
  return {
    type: GET_CATEGORY_SUCCESS,
    payload: value,
  }
}

export const uploadCategory = (params, callback) => {
  return {
    type: SAVE_UPLOAD_GATEGORY,
    payload: params,
    callback,
  }
}
export const getuploadcategorysuccess = value => {
  return {
    type: SAVE_UPLOAD_GATEGORY_SUCCESS,
    payload: value,
  }
}
export const getuploadcategoryError = error => {
  return {
    type: SAVE_UPLOAD_GATEGORY_ERROR,
    payload: error,
  }
}
export const addNewCategoryUser = (params, callback) => {
  return {
    type: CATEGORY_USER,
    payload: params,
    callback,
  }
}
export const categoryUsersuccess = value => {
  return {
    type: CATEGORY_USER_SUCCESS,
    payload: value,
  }
}
export const categoryUserError = error => {
  return {
    type: CATEGORY_USER_ERROR,
    payload: error,
  }
}
export const addNewSubCategory = (params, callback) => {
  return {
    type: SUB_CATEGORY,
    payload: params,
    callback,
  }
}
export const NewSubCategorysuccess = value => {
  return {
    type: SUB_CATEGORY_SUCCESS,
    payload: value,
  }
}
export const NewSubCategoryError = error => {
  return {
    type: SUB_CATEGORY_ERROR,
    payload: error,
  }
}
export const deleteUser = (id, callback) => {
  return {
    type: DELETE_CATEGORY_USER,
    payload: id,
    callback,
  }
}

export const deleteUserSuccess = value => {
  return {
    type: DELETE_CATEGORY_USER_SUCCESS,
    payload: value,
  }
}
export const deleteUserError = value => {
  return {
    type: DELETE_CATEGORY_USER_SUCCESS,
    payload: value,
  }
}
export const getUserbasedonProjects = value => {
  return {
    type: GET_USER_BY_PROJECT,
    payload: value,
  }
}

export const getUserSuccess = (value, params) => {
  return {
    type: GET_USER_BY_PROJECT_SUCCESS,
    payload: value,
    projectID: params,
  }
}

export const getUserError = value => {
  return {
    type: GET_USER_BY_PROJECT_ERROR,
    payload: value,
  }
}

export const CreateUserForProject = (value, callback) => {
  return {
    type: CREATE_USERS_FOR_PROJECTS,
    payload: value,
    callback,
  }
}
// create category link for user
export const postUserCategorylink = value => {
  return {
    type: CATEGORY_USER_CATEGORY_LINK,
    payload: value,
  }
}

export const postUserCategorylinkSuccess = value => {
  return {
    type: CATEGORY_USER_CATEGORY_LINK_SUCCESS,
    payload: value,
  }
}

export const postUserCategorylinkError = value => {
  return {
    type: CATEGORY_USER_CATEGORY_LINK_ERROR,
    payload: value,
  }
}
// project status get method
export const getProjectStatus = () => {
  return {
    type: GET_PROJECT_STATUS,
  }
}
export const getProjectStatusSuccess = value => {
  return {
    type: GET_PROJECT_STATUS_SUCCESS,
    payload: value,
  }
}
export const getProjectStatusError = value => {
  return {
    type: GET_PROJECT_STATUS_ERROR,
    payload: value,
  }
}

// get project total hours
// project status get method
export const getProjectStatusTotalHours = projectID => {
  return {
    type: GET_PROJECT_STATUS_TOTAL_HOURS,
    payload: projectID,
  }
}
export const getProjectStatusTotalHoursSuccess = value => {
  return {
    type: GET_PROJECT_STATUS_TOTAL_HOURS_SUCCESS,
    payload: value,
  }
}
export const getProjectStatusTotalHoursError = value => {
  return {
    type: GET_PROJECT_STATUS_TOTAL_HOURS_ERROR,
    payload: value,
  }
}
